import type { Product } from "../types/marketplace";
import CardItem from "./CardItem";

interface ProductStripProps {
  products: Product[];
  comparedProductIds?: string[];
  onCompareToggle?: (product: Product) => void;
  onProductSelect?: (product: Product) => void;
}

function ProductStrip({
  comparedProductIds = [],
  onCompareToggle,
  onProductSelect,
  products
}: ProductStripProps) {
  return (
    <div className="offer-products-grid">
      {products.map((product) => (
        <CardItem
          isCompared={Boolean(product.id && comparedProductIds.includes(product.id))}
          item={product}
          key={product.id ?? product.name}
          onCompareToggle={onCompareToggle}
          onSelect={onProductSelect}
        />
      ))}
    </div>
  );
}

export default ProductStrip;
